var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.optionsAndThemes.length)?_c('div',{staticClass:"quick-search",attrs:{"data-qa":"quick-search"}},[_c('ThemeBadges',{attrs:{"title":_vm.$t('header.quickSearch'),"themes":_vm.optionsAndThemes}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }